// client/src/modules/recruiting/index.ts
import type { ModuleManifest } from '../types';
import { navItems } from './nav';
import { routes } from './routes';

/**
 * Recruiting module manifest (P14)
 *
 * AI-first talent acquisition platform: candidates, job postings,
 * pipeline management, resume parsing, and market intelligence.
 * Built by Dillan with Nick reviewing for OfficeHub consistency.
 */
export const recruitingModule: ModuleManifest = {
  id: 'P14',
  name: 'Recruiting',
  shortName: 'Recruiting',
  description: 'AI-powered talent acquisition and recruiting pipeline',
  icon: '🎯',
  status: 'live',
  urlPrefix: '/recruiting',
  routes,
  navItems,
};

export default recruitingModule;
